import React from "react";
import "../styles/RelatedArticles.css";
import { RELATED_ARTICLES } from "../utils/ai_code_assistants";

const RelatedArticles = () => {
  return (
    <div className="related-articles">
      <h2>Related Article</h2>
      <div className="articles-grid">
        {RELATED_ARTICLES.map((article, index) => (
          <div key={index} className="article-card">
            <img src={article.image} alt={article.title} />
            <div className="article-content">
              <span className="date">{article.date}</span>
              <h3>{article.title}</h3>
              <p>{article.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedArticles;
